PJQ.views.budget.ProjectCostCodeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'project-cost-code-settings')
    },
    events: {},
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.options.project != null) {
            this.budget = await this.options.project.fetchBudget();
            this.subJobs = await this.options.project.fetchSubJobs();
            this.costCodes = await this.options.project.fetchCostCodes();

            await this.options.project.fetchERPObject();
        } else {
            this.costCodes = await PJQ.app.session.fetchCostCodes();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            budget: this.budget,
            isFetched: this.isFetched,
            enableSubJobs: _.size(this.subJobs) > 0 || this.options.enableSubJobs
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.views.budget.CostCodeSettings({
            el: this.$('.cost-codes-outer'),
            project: this.options.project,
            enableSubJobs: this.options.enableSubJobs,
            enableSubJobsChanged: (enableSubJobs) => {
                this.options.enableSubJobs = enableSubJobs;
                this.render();
            },
            onPullERP: () => {
                this.render();
            }
        });

        if (_.size(this.subJobs) > 0 || this.options.enableSubJobs) {
            new PJQ.views.budget.SubJobSettings({
                el: this.$('.sub-jobs-outer'),
                project: this.options.project
            });
        }
    }
});

PJQ.views.budget.CostCodeSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-cost-code-settings'),
        maxWidth: 800,
        pickerOptions: {},
        onPullERP: null
    },
    events: {
        'click .btn-close': 'close'
    },
    renderData: function () {
        return {
            project: this.options.project,
            subJob: this.options.subJob
        };
    },
    afterRender: function () {
        new PJQ.views.budget.CostCodeSettings({
            el: this.$('.cost-code-settings'),
            project: this.options.project,
            subJob: this.options.subJob,
            onPullERP: this.options.onPullERP
        });
    },
    close: function () {
        this.removeModal();
    }
});

PJQ.views.budget.CostCodeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'cost-code-settings'),
        enableSubJobsChanged: null,
        onPullERP: null
    },
    events: {
        'click .btn-import-cost-codes': 'importClicked',
        'click .btn-add-cost-code': 'addClicked',
        'click .btn-add-standard': 'addStandard',
        'click .btn-edit-cost-code': 'editClicked',
        'click .btn-delete-cost-code': 'deleteClicked',
        'click .btn-delete-all': 'deleteAll',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-pull-erp': 'pullERP',
        'change .cb-enable-sub-jobs': 'enableSubJobsChanged'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project != null ? this.options.project : PJQ.app.session.project;

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.options.project != null) {
            this.budget = await this.options.project.fetchBudget();
            this.subJobs = await this.options.project.fetchSubJobs();
            this.allCostCodes = await this.options.project.fetchCostCodes();

            if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
                await this.options.project.fetchERPObject();
            }
        } else {
            this.allCostCodes = await PJQ.app.session.fetchCostCodes();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return false;
        }

        if (this.costCodes == null) {
            let cc;
            if (this.options.subJob != null) {
                cc = this.allCostCodes.where({subJobId: this.options.subJob.id});
            } else {
                cc = this.allCostCodes.where({subJobId: null});
            }
            this.costCodes = new PJQ.collections.budget.CostCodes(cc, {
                projectId: this.options.project ? this.options.project.id : null,
                subJobId: this.options.subJob ? this.options.subJob.id : null
            });
        }
    },
    renderData: function () {
        return {
            project: this.options.project,
            subJobs: this.subJobs,
            subJob: this.options.subJob,
            costCodes: this.costCodes,
            isFetched: this.isFetched,
            erpIntegration: this.erpIntegration,
            enableSubJobs: this.options.enableSubJobs,
            budget: this.budget
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderCostCodeTable();
        this.renderERP();
    },
    renderCostCodeTable: function () {
        let hasDivisions = this.costCodes.hasDivisions(),
            data;
        if (hasDivisions) {
            let divisionNames = this.costCodes.getDivisions().sort(PJQ.helpers.sortHelpers.sortAlphaNum);
            data = _.map(divisionNames, (division, i) => {
                return {
                    cid: PJQ.helpers.guid(),
                    division: _.size(division) > 0 ? division : 'No Division',
                    isFetched: true,
                    sortOrder: i
                };
            })
        } else {
            data = this.costCodes.models;
        }

        if (this.dataTable && this.dataTable.dataTable) {
            this.dataTable.dataTable.destroy();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTable({
            el: this.$(".cost-codes-table"),
            data: data,
            afterDataTableRender: _.bind(function () {
                // if (hasDivisions && this.dataTable && this.dataTable.dataTable) {
                //     let self = this;
                //     this.dataTable.dataTable.row().$('.toggle-row').each(function () {
                //         self.dataTable.childRowToggle({currentTarget: this});
                //     });
                // }
            }, this),
            getRowChildTable: _.bind(function (childOpts) {
                if (!hasDivisions) {
                    return null;
                }
                return this.getDataTable(childOpts)
            }, this),
            getRowChildData: _.bind(function (row) {
                if (!hasDivisions) {
                    return null;
                }

                let costCode = row.data();
                return _.sortBy(this.costCodes.getForDivision(costCode.division), function (costCode) {
                    return costCode.get('code');
                });
            }, this),
            language: {
                zeroRecords: 'Click "Add Cost Code" to create a new Cost Code'
            }
        });
    },
    getDataTable: function (dtOptions) {
        let columns,
            hasDivisions = this.costCodes.hasDivisions();
        if (dtOptions.parentData == null && hasDivisions) {
            dtOptions = _.defaults(dtOptions, {
                order: [1, 'asc'],
            });
            columns = [
                {
                    "width": "15px",
                    "columnData": "division",
                    "data": null,
                    "title": "",
                    "className": "dt-center",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return '<i class="fal fa-plus-circle toggle-row" data-id="' + data.id + '"></i>';
                    }
                },
                {
                    "title": "Division",
                    "data": "division",
                    "orderable": true,
                    "render": function (data, type, row) {
                        if (type === 'sort' || type === 'type') {
                            return row.sortOrder;
                        }
                        return data;
                    }
                }
            ];
        } else {
            dtOptions = _.defaults(dtOptions, {
                order: [1, 'asc'],
                hideColumnHeaders: hasDivisions,
                onRowDoubleClick: _.bind(function (row) {
                    this.editCostCode(row.data());
                }, this),
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'Edit',
                            onClick: (row) => {
                                this.editCostCode(row.data());
                            }
                        },
                        {
                            name: 'Delete',
                            isDanger: true,
                            isShown: (row) => {
                                return null == this.budget.lineItems.findWhere({costCodeId: row.data().id});
                            },
                            onClick: (row) => {
                                this.deleteCostCode(row.data());
                            }
                        }
                    ]
                },
            });
            columns = [
                {
                    "width": "15px",
                    "columnData": "division",
                    "data": null,
                    "title": "",
                    "className": "dt-center",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": (data, type, row) => {
                        if (row.isERPSynced()) {
                            return '<div class="ml-1">' + PJQ.helpers.erp.getERPIcon(row.erpSyncStatus()) + '</div>';
                        }
                        return '';
                    }
                },
                {
                    "title": "Code",
                    "data": "attributes.code",
                    "width": "100px",
                    "render": (data, type, model) => {
                        if (type === 'sort' || type === 'type') {
                            return PJQ.helpers.costCodes.getDivisionSortValue(data);
                        }
                        return '<a class="btn-edit-cost-code" href="javascript:void(0)">' + data + '</a>';
                    }
                },
                {
                    "title": "Name",
                    "data": "attributes.name"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "className": "p-2",
                    "width": "80px",
                    "render": (data, type, model) => {
                        let canDelete = null == this.budget || null == this.budget.lineItems.findWhere({costCodeId: model.id}),
                            res = '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-edit-cost-code ml-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        if (canDelete) {
                            res += '<button type="button" class="btn btn-danger btn-delete-cost-code ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                        } else {
                            res += '<button type="button" disabled class="btn btn-danger ml-1 fs-14" title="This cost code has associated budget line items"><span class="fal fa-trash"></span></button>';
                        }
                        return res + '</div>';
                    }
                }
            ];
        }

        dtOptions.rowId = "cid";
        dtOptions.paging = false;
        dtOptions.columns = columns;
        return new PJQ.views.dataTables.DataTable(dtOptions);
    },
    importClicked: function () {
        new PJQ.views.budget.UploadCostCodesModal({
            costCodes: this.costCodes,
            project: this.options.project,
            subJob: this.options.subJob,
            onSave: _.bind(function (costCodes) {
                this.costCodes.add(costCodes);
                this.render();
            }, this)
        });
    },
    enableSubJobsChanged: function (e) {
        this.options.enableSubJobs = $(e.currentTarget).prop('checked');
        if (typeof this.options.enableSubJobsChanged === 'function') {
            this.options.enableSubJobsChanged(this.options.enableSubJobs);
        }
    },
    renderERP: function () {
        if (this.erpIntegration == null || (this.options.project != null && !this.options.project.isERPSynced())) {
            return;
        }

        let hasStaleCostCodes = null != _.find(this.costCodes.models, function (costCode) {
                return costCode.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.PENDING
                    || costCode.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.STALE;
            }),
            pushSupported,
            pullSupported,
            status;
        if (this.options.project) {
            let projectSyncStatus = this.options.project.erpSyncStatus(),
                isProjectReviewing = projectSyncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING;
            status = hasStaleCostCodes && !isProjectReviewing ? PJQ.constants.integrations.erp.syncStatuses.STALE : projectSyncStatus;
            pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES);
            pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PROJECT_COST_CODES);
        } else {
            pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMPANY_COST_CODES);
            status = pushSupported && hasStaleCostCodes ? PJQ.constants.integrations.erp.syncStatuses.STALE : PJQ.constants.integrations.erp.syncStatuses.SYNCED;
            // We've changed how cost codes are handled. You now pull cost codes from ERP Admin.
            pullSupported = false;
        }
        this.erpButtons = PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: pushSupported,
            canPush: hasStaleCostCodes,
            disablePushReason: !hasStaleCostCodes ? 'All cost code changes have been pushed to ERP' : '',
            pullSupported: pullSupported,
            status: status
        });

        let badge = PJQ.helpers.erp.getERPBadge(status);
        this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
    },
    pushERP: function () {
        if ((this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES))
            || (this.options.project == null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMPANY_COST_CODES))) {
            this.erpButtons?.pushing(true);
            this.erpIntegration.pushCostCodes({
                project: this.options.project
            }, (res, err) => {
                this.erpButtons?.pushing(false);
                if (res == null) {
                    return;
                }
                this.allCostCodes.reset(res);
                this.costCodes = null;
                PJQ.notifications.notify.successNotify({
                    message: this.options.project ? 'Project Cost Codes pushed for ERP approval' : 'Cost Codes successfully pushed to ERP'
                });
                this.render();
            });
        }
    },
    undoPushERP: function () {
        if (this.options.project.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.options.project, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Project Cost Codes successfully removed from ERP approval'
                });
                this.render();
            }, this));
        }
    },
    pullERP: function () {
        if ((this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PROJECT_COST_CODES))
            || (this.options.project == null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMPANY_COST_CODES))) {
            this.erpButtons?.pulling(true);
            this.erpIntegration.pullCostCodes(this.options.project, (newCostCodes, err) => {
                this.erpButtons?.pulling(false);
                if (newCostCodes == null) {
                    return;
                }

                this.allCostCodes.reset(newCostCodes);
                this.costCodes = null;
                PJQ.notifications.notify.successNotify({
                    message: _.size(newCostCodes).toString() + ' Cost Codes pulled from ERP'
                });
                if (typeof this.options.onPullERP === 'function') {
                    this.options.onPullERP();
                } else {
                    this.render();
                }
            });
        }
    },
    addStandard: function () {
        new PJQ.views.budget.CostCodePickerModal({
            title: 'Add Cost Codes To Project',
            pickerOptions: {
                showDisabledAsSelected: true,
                isCostCodeDisabled: _.bind(function (costCode) {
                    return null != _.find(this.costCodes.models, function (pCostCode) {
                        return pCostCode.get('code').toLowerCase() === costCode.get('code').toLowerCase();
                    })
                }, this)
            },
            onSave: _.bind(function (newCostCodes) {
                if (_.size(newCostCodes) > 0) {
                    this.costCodes.saveBulk(newCostCodes, this.options.subJob ? this.options.subJob.id : null, _.bind(function (savedCostCodes) {
                        if (savedCostCodes) {
                            if (this.options.project) {
                                this.options.project.costCodes.add(savedCostCodes);
                            }
                            this.render();
                            PJQ.notifications.notify.successNotify({
                                message: _.size(savedCostCodes).toString() + ' Company Cost Codes added to project'
                            });
                        } else {
                            // todo: error
                        }
                    }, this));
                }
            }, this)
        });
    },
    addClicked: function () {
        this.editCostCode(null);
    },
    editClicked: function (e) {
        let id = $(e.currentTarget).closest('tr').attr('id');
        if (_.size(id) > 0) {
            let costCode = this.costCodes.get(id);
            if (costCode != null) {
                this.editCostCode(costCode);
            }
        }
    },
    editCostCode: function (costCode) {
        new PJQ.views.budget.EditCostCodeModal({
            model: costCode,
            project: this.options.project,
            subJob: this.options.subJob,
            onSave: _.bind(function (costCode) {
                this.costCodes.add(costCode);
                if (this.options.project) {
                    this.options.project.costCodes.add(costCode);
                }
                this.render();
            }, this),
            // onClose: _.bind(function (costCode) {
            //     this.dataTable.refresh();
            // }, this),
            onDelete: _.bind(function (costCode) {
                if (costCode.id > 0) {
                    this.deleteCostCode(costCode);
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('tr').attr('id'),
            costCode = this.costCodes.get(cid);
        this.deleteCostCode(costCode);
    },
    deleteAll: function () {
        let msg,
            ct = _.size(this.costCodes.models);
        if (ct === 0) {
            return;
        }

        if (this.options.project != null) {
            msg = 'Are you sure you want to delete all Cost Codes from this project? This will only delete cost codes which are not on the budget.';
        } else {
            msg = 'Are you sure you want to delete all <strong>' + ct + '</strong> Company Cost Codes?';
        }
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: msg,
            onDelete: _.bind(function () {
                this.costCodes.deleteAll(_.bind(function (result) {
                    if (this.options.project != null) {
                        this.options.project.costCodes.reset(result);
                        this.costCodes.reset(result);
                    } else {
                        this.costCodes.reset([]);
                    }
                    PJQ.notifications.notify.successNotify({
                        message: (ct - _.size(this.costCodes.models)).toString() + ' Cost Codes deleted'
                    });
                    this.render();
                }, this));
            }, this)
        });
    },
    deleteCostCode: function (costCode) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Cost Code?",
            onDelete: _.bind(function () {
                costCode.destroy({
                    notify: false,
                    success: _.bind(function () {
                        if (this.options.project) {
                            this.options.project.costCodes.remove(costCode);
                        }
                        this.costCodes.remove(costCode);
                        this.render();
                    }, this),
                    error: function (model, xhr) {
                        if (xhr.responseJSON != null && xhr.responseJSON.type === 'delete_code_with_line_item') {
                            PJQ.notifications.notify.warningNotify({
                                message: 'This cost code cannot be deleted because it is being used on budget line items.'
                            });
                        }
                    }
                });
            }, this)
        });
    }
});

PJQ.views.budget.EditCostCodeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-cost-code'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-delete': 'delete',
        'keydown .input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent'
    },
    beforeModalCreated: async function () {
        if (this.model == null) {
            this.model = new PJQ.models.budget.CostCode({
                projectId: this.options.project ? this.options.project.id : null,
                subJobId: this.options.subJob ? this.options.subJob.id : null
            });
        }

        let fnRender = _.bind(function () {
            PJQ.app.session.fetchCostTypes(_.bind(function (costTypes) {
                this.costTypes = costTypes;
                this.isFetched = true;
                this.render();
            }, this));
        }, this);

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if(this.erpIntegration != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.DISABLE_EDIT_COST_CODE_TYPE_FILTER)) {
            this.options.disableEditingCostTypeFilter = true;
        }

        if (this.options.project != null) {
            if(this.erpIntegration != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PROJECT_COST_CODES) && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES)) {
                this.options.disableEditingCostCodeName = true;
            }

            this.options.project.fetchCostCodes(_.bind(function (costCodes) {
                this.costCodes = costCodes;
                fnRender();
            }, this));
        } else {
            if(this.erpIntegration != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMPANY_COST_CODES) && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMPANY_COST_CODES)) {
                this.options.disableEditingCostCodeName = true;
            }

            PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
                this.costCodes = costCodes;
                fnRender();
            }, this));
        }
    },
    renderData: function () {
        return {
            model: this.model,
            costTypes: this.costTypes,
            isFetched: this.isFetched,
            disableEditingCostCodeName: this.options.disableEditingCostCodeName
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'select'
            ]
        });

        let divisions = this.costCodes.getDivisions();
        new PJQ.inputs.AutocompleteInput({
            el: this.$('.input-division'),
            source: divisions
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-types'),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'All Cost Types',
            isDisabled: this.options.disableEditingCostTypeFilter,
            defaultValue: this.model.get('costTypeIds')
        });
    },
    formatPercent: function (e) {
        let val = $(e.currentTarget).val();
        if (val !== "") {
            $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent(val));
        }
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, true, true);
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        let $code = this.$('.input-code'),
            code = $code.val(),
            subJobId = this.model.get('subJobId'),
            isCodeValid = true,
            errorText = '';
        if (_.size(code) === 0) {
            isCodeValid = false;
        } else if (null != _.find(this.costCodes.models, _.bind(function (cc) {
            return cc.id !== this.model.id && (subJobId == null || subJobId === cc.get('subJobId')) && cc.get('code').toLowerCase() === code.toLowerCase();
        }, this))) {
            isCodeValid = false;
            errorText = 'This code already exists'
        }
        PJQ.helpers.inputHelpers.setInputError($code, isCodeValid, {
            errorText: errorText
        });
        return isCodeValid;
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.costCodes.add(this.model);
                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Cost Code saved'
                    });
                }, this)
            });
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Cost Code?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.budget.UploadCostCodesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-upload-cost-codes'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save-new': 'saveNew',
        'click .btn-save-all': 'saveAll'
    },
    renderData: function () {
        return {
            data: this.data,
            isSaving: this.isSaving
        };
    },
    saveNew: function () {
        this.save(_.filter(this.data, function (dt) {
            return !(dt.id > 0);
        }))
    },
    saveAll: function () {
        this.save(this.data);
    },
    save: function (costCodes) {
        this.isSaving = true;
        this.render();
        this.$('.import-loading').removeClass('hidden');
        this.options.costCodes.saveBulk(costCodes, this.options.subJob ? this.options.subJob.id : null, (savedCostCodes) => {
            this.isSaving = false;
            if (savedCostCodes) {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(savedCostCodes);
                }
                this.removeModal();
                PJQ.notifications.notify.successNotify({
                    message: _.size(savedCostCodes).toString() + ' Cost Codes imported'
                });
            } else {
                // todo: error
            }
        });
    },
    afterRender: function () {
        if (this.data == null) {
            let $uploader = this.$('.template-uploader');
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                uploadTemplateCallback: () => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'costcodes'
                        },
                        {
                            endpoint: 'import'
                        },
                        {
                            endpoint: 'template'
                        }
                    ]), {isAPIv2: true});
                },
                maxFiles: 1,
                style: 'grid',
                onDrop: _.bind(function () {
                    this.$('.import-processing').removeClass('hidden');
                    this.$('.btn-close').prop('disabled', true);
                }, this),
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    if (this.options.costCodes != null && _.size(file.uploadId) > 0) {
                        this.options.costCodes.processImport(file.uploadId, this.options.project ? this.options.project.id : null, (data) => {
                            this.fileUploader.remove();
                            loader.remove();
                            this.fileUploader = null;
                            this.data = data;
                            this.render();
                        });
                    }
                }, this)
            });
        }
    }
});

PJQ.views.budget.CostCodePickerModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-cost-code-picker'),
        maxWidth: 600,
        pickerOptions: {}
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close'
    },
    renderData: function () {
        return {
            options: this.options
        };
    },
    beforeModalCreated: function () {
        this.selectedCostCodes = [];
    },
    afterRender: function () {
        new PJQ.views.budget.CostCodePicker(_.defaults(this.options.pickerOptions, {
            el: this.$('.cc-picker'),
            costCodes: this.options.costCodes,
            onSelectionChanged: _.bind(function (costCodes) {
                this.selectedCostCodes = costCodes;
            }, this)
        }));
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
        this.removeModal();
    },
    save: function () {
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.selectedCostCodes);
        }
        this.removeModal();
    }
});

PJQ.views.budget.CostCodePicker = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'cost-code-picker-container'),
        subTemplates: {
            picker: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'cost-code-picker')
        },
        costCodes: null,
        selectedCostCodeIds: null,
        selectecCostCodeCodes: null,
        disabledCostCodeIds: null,
        onSelectionChanged: null,
        isCostCodeDisabled: null,
        showDisabledAsSelected: false
    },
    events: {
        "keyup .input-search": "renderCostCodes",
        "click .btn-clear-filters": "clearFilters",
        "click .cost-codes-all-select": "selectAll",
        "click .division-select": "selectDivision",
        "click .cost-code-select": "selectionChanged",
        "click .division-expand": "expandDivisionClicked"
    },
    beforeFirstRender: function () {
        this.selectedCostCodeIds = [];
        if (_.size(this.options.selectedCostCodeIds) > 0) {
            this.selectedCostCodeIds = this.options.selectedCostCodeIds;
        }

        this.isFetched = false;
        if (this.options.costCodes == null) {
            PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
                this.costCodes = costCodes;
                this.isFetched = true;
                this.render();
            }, this));
        } else {
            this.costCodes = this.options.costCodes;
            this.isFetched = true;
        }
    },
    renderData: function () {
        return {
            costCodes: this.costCodes,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }
        this.renderCostCodes();
    },
    renderCostCodes: function () {
        let searchFilter = this.$('.input-search').val().toLowerCase(),
            costCodes = [],
            $clearFilters = this.$('.btn-clear-filters');
        if (_.size(searchFilter) > 0) {
            $clearFilters.prop('disabled', false);
            _.each(this.costCodes.models, _.bind(function (costCode) {
                if (costCode.getDisplayName().toLowerCase().indexOf(searchFilter) > -1) {
                    costCodes.push(costCode);
                }
            }, this));
        } else {
            $clearFilters.prop('disabled', true);
            costCodes = this.costCodes.models;
        }

        let divisions = null;
        if (this.costCodes.hasDivisions()) {
            divisions = {};
            _.each(costCodes, function (costCode) {
                let division = _.size(costCode.get('division')) > 0 ? costCode.get('division') : 'No Division';
                if (divisions[division] != null) {
                    divisions[division].costCodes.push(costCode);
                } else {
                    divisions[division] = {
                        name: division,
                        costCodes: [costCode]
                    }
                }
            });
        }
        this.renderSubTemplate(false, this.options.subTemplates.picker, this.$('.cost-codes-container'), {
            isCostCodeDisabled: this.isCostCodeDisabled,
            isCostCodeSelected: this.isCostCodeSelected,
            costCodes: costCodes,
            divisions: divisions,
            selectedCostCodeIds: this.selectedCostCodeIds,
            isFetched: this.isFetched,
            options: this.options
        }, _.bind(function () {
            this.setDisabledDivisions();
            this.setSelectedDivisions();
            this.isRendered = true;
        }, this));
    },
    setSelectedDivisions: function () {
        let self = this;
        this.$('.division-select').each(function () {
            $(this).prop('checked', _.size(self.getDivisionCostCodesContainer($(this)).find('.cost-code-select').not(':checked')) === 0);
        });
        this.$('.cost-codes-all-select').prop('checked', !(this.$('.cost-code-select:not(:checked)').length > 0));
    },
    setDisabledDivisions: function () {
        let self = this;
        this.$('.division-select').each(function () {
            $(this).prop('disabled', _.size(self.getDivisionCostCodesContainer($(this)).find('.cost-code-select').not(':disabled')) === 0);
        });
        this.$('.cost-codes-all-select').prop('disabled', !(this.$('.cost-code-select:not(:disabled)').length > 0));
    },
    clearFilters: function () {
        this.$('.input-search').val('');
        this.renderCostCodes();
    },
    selectAll: function (override) {
        if (typeof override === 'boolean')
            this.$('.cost-codes-all-select').prop('checked', override);

        let checkboxes = this.$('.cost-code-select:not(:disabled)');
        if (this.$('.cost-codes-all-select').prop('checked')) {
            checkboxes.prop('checked', true);
        } else {
            checkboxes.prop('checked', false);
        }
        this.selectionChanged();
    },
    getDivisionCostCodesContainer: function ($element) {
        return $element.closest('.division-outer').find('.division-cost-codes');
    },
    selectDivision: function (e) {
        let $costCodes = this.getDivisionCostCodesContainer($(e.currentTarget)),
            isChecked = $(e.currentTarget).is(':checked');
        $costCodes.find('.cost-code-select,.division-select').not(':disabled').prop('checked', isChecked);
        this.selectionChanged();
    },
    selectionChanged: function () {
        let checkboxes = this.$('.cost-code-select:checked').not(':disabled');
        this.selectedCostCodeIds = _.map(checkboxes, function (cb) {
            return $(cb).data('id');
        });

        this.setSelectedDivisions();
        if (typeof this.options.onSelectionChanged === 'function') {
            this.options.onSelectionChanged(this.costCodes.get(this.selectedCostCodeIds));
        }
    },
    expandDivisionClicked: function (e) {
        this.expandDivision(this.getDivisionCostCodesContainer($(e.currentTarget)));
    },
    expandDivision: function (container) {
        let icon = container.siblings('i.division-expand');
        if (container.hasClass('hidden')) {
            container.removeClass('hidden');
            icon.removeClass('fa-chevron-right text-primary').addClass('fa-chevron-down text-muted');
        } else {
            container.addClass('hidden');
            icon.removeClass('fa-chevron-down text-muted').addClass('fa-chevron-right text-primary');
        }
    },
    isCostCodeSelected: function (costCode) {
        return this.selectedCostCodeIds.indexOf(costCode.id) !== -1;
    },
    isCostCodeDisabled: function (costCode) {
        if (typeof this.options.isCostCodeDisabled === 'function') {
            return this.options.isCostCodeDisabled(costCode);
        }
        return false;
    },
    showError: function (errorText) {
        this.hideError();
        this.errorAlert = new PJQ.Alert(this.$el, {
            type: 'danger',
            extraClasses: ['mt-1, mb-1'],
            text: errorText,
            isPrepend: true
        });
    },
    hideError: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
    }
});